import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { 
  Car, 
  LayoutDashboard, 
  Users, 
  CalendarCheck, 
  Truck, 
  UserPlus, 
  CreditCard,
  LogOut,
  Home,
  Mail
} from 'lucide-react';

const AdminSidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const menuItems = [
    { path: '/admin', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/admin/customers', icon: Users, label: 'Customers' },
    { path: '/admin/bookings', icon: CalendarCheck, label: 'Bookings' },
    { path: '/admin/vehicles', icon: Truck, label: 'Vehicles' },
    { path: '/admin/leads', icon: UserPlus, label: 'Leads' },
    { path: '/admin/payments', icon: CreditCard, label: 'Payments' },
    { path: '/admin/reminders', icon: Mail, label: 'Reminders' },
  ];

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <aside className="crm-sidebar w-64 flex flex-col" data-testid="admin-sidebar">
      {/* Logo */}
      <div className="p-6 border-b border-slate-800">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
            <Car className="w-5 h-5 text-white" />
          </div>
          <div>
            <span className="font-bold text-white block">Fair Rideshare</span>
            <span className="text-xs text-slate-500">Admin Panel</span>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        <ul className="space-y-1">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`crm-sidebar-item ${isActive ? 'active' : ''}`}
                  data-testid={`sidebar-${item.label.toLowerCase()}`}
                >
                  <item.icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-slate-800">
        <div className="mb-4 px-3">
          <p className="text-sm text-white font-medium">{user?.name}</p>
          <p className="text-xs text-slate-500">{user?.email}</p>
        </div>
        <Link to="/" className="crm-sidebar-item" data-testid="sidebar-home">
          <Home className="w-5 h-5" />
          <span>Back to Site</span>
        </Link>
        <button onClick={handleLogout} className="crm-sidebar-item w-full" data-testid="sidebar-logout">
          <LogOut className="w-5 h-5" />
          <span>Logout</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
